import { FulfillmentOrderAddressWithIdSchema } from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import { z, null as zNull } from "zod";

export const getReturnAddresses = {
  input: zNull(),
  output: z.object({ addresses: z.array(FulfillmentOrderAddressWithIdSchema) }),
};
